import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SupplierInvoiceForm from '../supplier_invoice_form/SupplierInvoiceForm';
import { EditPage } from '../edit_page/EditPage';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { getEntityById } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	getInvoiceSubUrl,
	getInvoiceRestCrudThunksContractorId,
} from '../invoice_utilities/InvoiceUtilities';

const queryString = require('qs');

class EditSupplierInvoicePage extends React.Component<any, any> {
	state = {
		invoice: {},
		fetching: true,
	};

	componentDidMount() {
		const { getInvoice, match } = this.props;
		const invoiceId = match.params.id;
		getInvoice(invoiceId)
			.then((invoice) => {
				this.setState({ invoice, fetching: false });
			})
			.catch(() => {
				this.setState({ fetching: false });
			});
	}

	render() {
		const { history, location, userType, currentUser } = this.props;
		const { invoice, fetching } = this.state;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const pathName = getInvoiceSubUrl(userType, currentUser, invoice);
		//noinspection TypeScriptUnresolvedVariable
		return [
			<LogOnMountWithStandardEventProperties eventType="visited supplier edit invoice page" />,
			<EditPage
				title={`Edit Invoice ${invoice.id}`}
				formComponentProps={{
					formData: invoice,
					onSuccess: (rec) => {
						if (!!queryParams.btwo) {
							history.push(`/supplier/workOrders/detail/${rec.workOrderId}/invoices`);
						} else {
							history.push(`/${pathName}/detail/${rec.id}`);
						}
					},
				}}
				fetching={fetching}
				FormComponent={SupplierInvoiceForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		location: ownProps.location,
		invoice: getEntityById(ownProps.match.params.id, state.invoices),
		fetching: state.invoices.fetching,
		match: ownProps.match,
		currentUser: state.session.currentUser,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getInvoice: (id) =>
		dispatch(getInvoiceRestCrudThunksContractorId(ownProps.userType, false).readOne(id)),
});

const InvoicesHOC = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditSupplierInvoicePage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	(dispatch, ownProps) => ({})
)(InvoicesHOC);
